import React, { useEffect, useState } from 'react';
import {
    Text,
    View
} from 'react-native';

import { styles } from "./InvestFlowViewStyle";
import InvestFlowHeaderView from "./components/investflowheader/InvestFlowHeaderView";
import UsersService from "../../../Proxy/UsersService";
import ProjectsService from "../../../Proxy/ProjectsService";
import Project from "../../../Common/DTO/Project";
import User from "../../../Common/DTO/User";
import InvestFlowSubscriptionConfirmationView
    from "./components/subscriptionconfirmation/InvestFlowSubscriptionConfirmationView";
import { calculateUserTotalInvestments } from "../../../Common/Utils/total.investments.utils";
import InvestFlowTouchableButtonView from "./components/touchablebutton/InvestFlowTouchableButtonView";
import InvestFlowConsentsView from "./components/investflowconsents/InvestFlowConsentsView";
import InvestFlowFormView from "./components/investflowform/InvestFlowFormView";
import { Application, LanguageManager, Managers, NavigationManager, TranslationManager } from '@levelapp/softfabric';
import { TranslationView } from "@levelapp/softfabric-ui";
import App from "../../../App";
import { clearToken, getToken } from "../../../Common/Utils/token.utils";
import FooterView from "../details/components/footer/FooterView";
import HeaderView from "../details/components/header/HeaderView";

interface InvestFlowViewProps {
    code: string;
}

export interface UserElement {
    name: string;
    isLegalEntity: boolean;
    id: number;
}

export const InvestFlowView = ({ code }: InvestFlowViewProps) => {

    const userService = new UsersService();
    const projectService = new ProjectsService();
    const token = getToken();

    const [project, setProject] = useState<Project | null>(null);
    const [user, setUser] = useState<User | null>(null);

    const [amountStep, setAmountStep] = useState<number>(0);
    const [amount, setAmount] = useState<number>(0);
    const [selectedUser, setSelectedUser] = useState<UserElement | null>(null);
    const [users, setUsers] = useState<UserElement[]>([]);
    const [acceptTermsOfUse, setAcceptTermsOfUse] = useState<boolean>(false);
    const [acceptDefinitiveSubscription, setAcceptDefinitiveSubscription] = useState<boolean>(false);

    const [showMaximumTicketReachedView, setShowMaximumTicketReachedView] = useState<boolean>(false);
    const [showResult, setShowResult] = useState<boolean>(false);
    const [errors, setErrors] = useState<string[]>([]);

    const translationManager: TranslationManager = App.current.resolve<TranslationManager>(Managers.TRANSLATION_MANAGER);
    const languageManager: LanguageManager = App.current.resolve<LanguageManager>(Managers.LANGUAGE_MANAGER);

    const errorAmountMustBeGreaterTranslationKey = "investflow.error.amount.must.be.greater";
    const errorAmountMustBeMultipleTranslationKey = "investflow.error.amount.must.be.multiple";
    const errormax1000EurosOr5Percent = "investflow.error.max1000EurosOr5Percent";

    const getUserFullName = (user: User) => {
        return user.firstName + " " + user.lastName;
    }

    function fetchSetUser() {
        userService.getAll((userFound: User) => {
            setUser(userFound);
            if (!userFound.formCompletionDate || (userFound?.userStatusId != 2 && userFound?.userStatusId != 16)) {
                Application.current?.resolve<NavigationManager>(Managers.NAVIGATION_MANAGER)?.navigate(`/completeAccount`);
                return;
            }
            const user = {
                name: getUserFullName(userFound),
                isLegalEntity: false,
                id: userFound.id,
                isAverti: userFound.isAverti,
                hasSucceededTests: userFound.hasSucceededTests,
                investLimit: userFound.investLimit
            };
            setSelectedUser(user);

            const legalEntities = userFound.legalEntities.map((x): UserElement => {
                return {
                    id: x.id,
                    name: x.bceNumber,
                    isLegalEntity: true
                };
            });

            setUsers((prev) => [...prev, user, ...legalEntities]);
        }, () => {
            clearToken();
            back();
        });
    }

    function fetchSetProject() {
        projectService.getByCode(code, (project: Project) => {
            setProject(project);
            setAmountStep(project.minimumTicket);
            setAmount(project.minimumTicket);
        });
    }

    function translateKeyWithData(key: string, data: any): string {
        return translationManager.translate(key, languageManager.language).replace("${data}", data.toString())
    }

    function checkFormValidity() {
        setShowMaximumTicketReachedView(false);
        const tempErrors = [];
        if (amount < amountStep) tempErrors.push(errorAmountMustBeGreaterTranslationKey);
        if (amount % amountStep !== 0) tempErrors.push(errorAmountMustBeMultipleTranslationKey)
        if (!user) tempErrors.push("investflow.login");
        else if (!selectedUser) tempErrors.push("investflow.error.select.user");
        if (!acceptTermsOfUse) tempErrors.push("investflow.error.consents.terms.of.use");
        if (!acceptDefinitiveSubscription) tempErrors.push("investflow.error.consents.definitive.subscription");
        if (!project) tempErrors.push("investflow.error.project.unknown");
        if(project?.code === "RWDM") {
           
        }
        if(user?.hasSucceededTests) {
           
        }
        else if (!user?.isAverti && (!user?.numberOfFormsAttempts || user?.numberOfFormsAttempts === 0)) {
            if (amount > 1000) {
                tempErrors.push("investflow.error.max1000");
            }
        }
        else if (!user?.isAverti && user?.hasSucceededTests && amount > user?.investLimit) {
        }
        else if (!user?.isAverti && !user?.hasSucceededTests && user?.investLimit && amount > user?.investLimit) {
            tempErrors.push("investflow.error.max1000EurosOr5Percent");
        }
        else if (!user?.isAverti && amount > 1000 && !user?.investLimit) {
            tempErrors.push("investflow.error.max1000");
        }
        else if (!user?.isAverti && !user?.hasSucceededTests && user?.investLimit == 1000 && amount > user?.investLimit) {
            tempErrors.push("investflow.error.max1000");
        }




        setErrors(tempErrors);

        if (tempErrors.length === 0 && user && project) {
            const totalInvestments = calculateUserTotalInvestments(user, project.code);

            if (project.maximumTicket > 0 && totalInvestments + amount > project.maximumTicket) {
                setShowMaximumTicketReachedView(true);
                return;
            }

            setShowResult(true);
        }
    }

    function back() {
        Application.current?.resolve<NavigationManager>(Managers.NAVIGATION_MANAGER)?.navigate(`/details/${code}`);
    }

    useEffect(() => {

        if (!token) {
            back();
            return;
        }

        if (!user) {
            fetchSetUser();
        }
        if (!project) {
            fetchSetProject();
        }
    }, []);

    if (!token) return null;

    return (
        <View style={[styles.page]}>
            <HeaderView />
            <View style={styles.investFormContainer}>
                {!project ? (
                    <>
                        <TranslationView>Chargement...</TranslationView>
                    </>
                ) : (
                    <View style={{ width: '40%' }}>
                        {showMaximumTicketReachedView && (
                            <>
                                <InvestFlowHeaderView titleTranslationKey="investflow.flow.maximum.ticket.reached"
                                    titleTranslationData={project?.maximumTicket ?? 0} />
                                <View style={{ height: 15 }} />
                                <InvestFlowTouchableButtonView pressableButtonStyle={{ backgroundColor: "BEE_YELLOW" }}
                                    translationKey="investflow.button.go.back.invest"
                                    action={() => setShowMaximumTicketReachedView(false)} />
                            </>
                        )}
                        {showResult && (
                            <>
                                <InvestFlowSubscriptionConfirmationView user={user} setShowResult={setShowResult}
                                    amount={amount} project={project}
                                    selectedUser={selectedUser} />
                            </>
                        )}
                        {!showResult && !showMaximumTicketReachedView && project && (
                            <>
                                <InvestFlowHeaderView titleTranslationKey="investflow.title.amount" />
                                <InvestFlowFormView users={users} amountStep={amountStep} amount={amount}
                                    setAmount={setAmount} selectedUser={selectedUser} project={project}
                                    setSelectedUser={setSelectedUser} />

                                <View style={{ height: 25 }} />

                                <InvestFlowConsentsView
                                    acceptTermsOfUse={acceptTermsOfUse}
                                    setAcceptTermsOfUse={setAcceptTermsOfUse}
                                    acceptDefinitiveSubscription={acceptDefinitiveSubscription}
                                    setAcceptDefinitiveSubscription={setAcceptDefinitiveSubscription}
                                />

                                <View style={{ height: 45 }} />

                                <View style={styles.buttonsContainer}>
                                    <InvestFlowTouchableButtonView
                                        pressableButtonStyle={{
                                            backgroundColor: "DUCK_BLUE",
                                            paddingVertical: 10,
                                            fontSize: 10,
                                            marginRight: 12
                                        }}
                                        translationKey="investflow.button.cancel"
                                        action={back}
                                    />

                                    <InvestFlowTouchableButtonView
                                        pressableButtonStyle={{
                                            backgroundColor: "BEE_YELLOW",
                                            paddingVertical: 10,
                                            fontSize: 10
                                        }}
                                        translationKey="investflow.button.validate"
                                        action={checkFormValidity}
                                    />
                                </View>

                                <View style={{ height: 35 }} />

                                {errors.length > 0 && (
                                    <>
                                        <TranslationView
                                            style={[styles.errorMessage, styles.errorMessageTitle]}>investflow.title.errors</TranslationView>
                                        <View style={[styles.errorsContainer]}>
                                            {errors.map((error: string, index: number) => {
                                                if (error === errorAmountMustBeGreaterTranslationKey || error === errorAmountMustBeMultipleTranslationKey) {
                                                    return <Text style={[styles.errorMessage]}
                                                        key={index}>{translateKeyWithData(error, amountStep)}</Text>
                                                }
                                                if (error === errormax1000EurosOr5Percent) {
                                                    return <Text style={[styles.errorMessage]}
                                                        key={index}>{translationManager.translate(error, languageManager.language) + " " + (user?.investLimit?.toString() ?? "") + "€"}</Text>
                                                }
                                                return (
                                                    <TranslationView style={[styles.errorMessage]}
                                                        key={index}>{error}</TranslationView>
                                                );
                                            })}
                                        </View>
                                    </>
                                )}
                            </>
                        )}
                    </View>
                )}
            </View>
            <FooterView />
        </View>
    );
}

export default InvestFlowView;